import styled from 'styled-components/macro'


export const Container = styled.div`
 background: linear-gradient(
90deg, #010030 21.67%, #29268C 57.01%, #010030 84.45%);
display: flex;
justify-content: center;
align-items: center;
padding: 3rem 0;

`

export const Row = styled.div`
    width: 100%;
    max-width: 1300px;
    padding: 0 2rem;
    color: #fff;
`


export const Title = styled.div`
 font-size: 30px;
 line-height: 1.2;
 
   @media (max-width:600px){
  
    font-size: 25px;
   }
`

export const Subtitle = styled.div``